import React, { Fragment, useEffect, useState } from 'react';
import { Row, Label, Alert, Input, Collapse } from 'reactstrap';
import '../estilos.css';
import * as IoIcons from 'react-icons/io';
import Moment from 'moment';
import { obtenerPlaneacionBF, ObtenerSerialesPProduccion, seguimientoProduccion } from '../queries/DCUbicaciones';
import Graficapietabla from '../graficas/Graficapietabla';
import { backgroundColorRGB, borderColorRGB } from '../graficas/colores';
import MetricasPBSeguimiento from './MetricasPBSeguimiento';
import BarChart from '../graficas/BarChart';
import { GetPProduccionGeneral, GetProductos } from '../queries/Queries';


function MetricasPB() {
    //Declaración de variables        

    const [fechaPB, setFechaPB] = useState(Moment().format("YYYY-MM-DD"));
    const pMetricas = window.$Metricas;
    const [datosPBF, setDatosPBF] = useState([]);
    const [datosPBFP, setDatosPBFP] = useState([]);
    const [datosOriginales, setDatosOriginales] = useState([]);
    const [datosPBS, setDatosPBS] = useState([]);
    const [datosPBSP, setDatosPBSP] = useState([]);
    const [mensajeAlert, setMensajeAlert] = useState("No fue posible realizar la operación, error indeterminado: revise su conexión a internet, recargue la página y vuelva a intentarlo, si el error persiste, favor de comunicarse a sistemas");
    const [color, setColor] = useState("warning");
    const [aVisible, setAVisible] = useState(false);
    const onDismiss = () => setAVisible(false);
    const [openPB, setOpenPB] = useState(false);
    const [openPP, setOpenPP] = useState(false);
    const [openPBP, setOpenPBP] = useState(false);
    const [openPPP, setOpenPPP] = useState(false);
    const [hora, setHora] = useState("");
    const [espaciosVacios, setEspaciosVacios] = useState(0);
    const [espacioHistorial, setEspacioHistorial] = useState([]);
    const [datosSeguimientoO, setDatosSeguimientoO] = useState([]);

    const [cargando, setCargando] = useState(false);
    const [cargando1, setCargando1] = useState(false);
    const [datosPB, setDatosPB] = useState({});

    useEffect(() => {
        datosPlaneacionBF(fechaPB);
    }, []);

    //Asigna los datos de la planeación pase por fecha
    async function datosPlaneacionBF(fechaActual) {
        setCargando(true);
        setAVisible(false);
        //Se obtienen los datos de la planeación base por fecha
        const datosPBF = await obtenerPlaneacionBF(fechaActual);
        setDatosOriginales(datosPBF);
        //Se obtienen los datos para las gráficas de la planeación base
        const datosPlaneacionB = await obtenerDatosPBF(fechaActual, datosPBF, "Ecoat");
        setDatosPBF(datosPlaneacionB);
        //Se obtienen los datos para las gráficas de la planeación base Powder
        const datosPlaneacionBP = await obtenerDatosPBF(fechaActual, datosPBF, "Pcoat");
        setDatosPBFP(datosPlaneacionBP);
        //Se obtienen los datos de la planeación base
        const datosPlaneacionBS = await obtenerDatosPBS(fechaActual, datosPBF, "Ecoat");
        setDatosPBS(datosPlaneacionBS);
        //Se obtienen los datos de la planeación base
        const datosPlaneacionBSP = await obtenerDatosPBS(fechaActual, datosPBF, "Pcoat");
        setDatosPBSP(datosPlaneacionBSP);
        setCargando(false);
    }

    //Función que obtiene los datos agrupados de la planeación base por fecha
    //para las métricas.
    async function obtenerDatosPBF(fechaActual, datosPBF, proceso) {
        var datoscc = [];
        var numero = 1; //Se inicializa el número para el primer cliente
        var racks = 0;
        var ciclos = 0;
        datosPBF = proceso === "Ecoat" ? datosPBF.filter(pbe => pbe.Ecoat === true || (!pbe.Ecoat && !pbe.Pcoat)) :
            proceso === "Pcoat" ? datosPBF.filter(pbe => pbe.Pcoat === true) : datosPBF;
        // const cantidadTotalPiezas = 0;
        const cantidadTotalPiezas = datosPBF.reduce((total, planeaciob) => total + planeaciob.cantidadPiezas, 0);
        //Se ordenan los datos de la planeación base por cliente
        const datosPBOrdenada = datosPBF.sort((a, b) => a.cliente.localeCompare(b.cliente));
        //Se recorren los datos de la planeación base
        await Promise.all(datosPBOrdenada.map(async (planeacion) => {
            //Se obtiene el cliente de la planeación
            const cliente = planeacion.cliente;
            //Se obtiene la cantidad de piezas de la planeación
            const cantidadPiezas = planeacion.cantidadPiezas;
            //cantidadTotalPiezas += planeacion.cantidadPiezas;
            //Se obtienen los racks de la planeación
            const rackscc = parseFloat(planeacion.racks ? planeacion.racks : 0);
            //Se suman los racks de la planeación
            racks += parseFloat(planeacion.racks ? planeacion.racks : 0);
            //se obtiene los ciclos de la planeación
            const cicloscc = parseInt(planeacion.ciclos ? planeacion.ciclos : 0);
            //Se suman los ciclos de la planeación
            ciclos += parseInt(planeacion.ciclos ? planeacion.ciclos : 0);

            //Se verifica si el cliente ya existe en el arreglo
            const clienteExistente = datoscc.find(c => c.cliente === cliente);
            if (clienteExistente) {
                //Si el cliente ya existe, se suma la cantidad de piezas
                clienteExistente.cantidadPiezas += cantidadPiezas;
                clienteExistente.racks += rackscc;
                clienteExistente.ciclos += cicloscc;
            } else {//Si el cliente no existe, se agrega a los arreglos correspondientes
                //clientescc.push(cliente); // Agrega el cliente al arreglo de clientes
                //cantidadPiezascc.push(cantidadPiezas); //Se agrega la cantidad de piezas al arreglo de cantidades
                datoscc.push({ //Se agregan todos los datos al arreglo de datos
                    numero: numero,
                    cliente: cliente,
                    racks: rackscc,
                    ciclos: cicloscc,
                    cantidadPiezas: cantidadPiezas,
                    porcentaje: cantidadPiezas
                });
                numero++; //Se incrementa el número para el siguiente cliente
            }
        }));
        var clientescc = [];
        var cantidadPiezascc = [];
        var porcentajePiezasPorCliente = [];
        var graficasPorCliente = [{}];
        await Promise.all(datoscc.map(async (planeacion) => {
            //Se obtienen los datos de la columna cliente
            clientescc.push(planeacion.cliente + " (" + planeacion.cantidadPiezas + "p)");
            //Se obtienen los datos de la columna cantidadPiezas
            cantidadPiezascc.push(planeacion.cantidadPiezas);
            //Se calcula el porcentaje de piezas por cliente
            porcentajePiezasPorCliente.push(((planeacion.cantidadPiezas / cantidadTotalPiezas) * 100).toFixed(2));
            planeacion.racks = planeacion.racks ? planeacion.racks.toFixed(2) : 0;
            planeacion.porcentaje = (planeacion.cantidadPiezas ? ((planeacion.cantidadPiezas / cantidadTotalPiezas) * 100).toFixed(2) : 0) + " %";
            //Se arman los datos por clientes
            const porClientes = datosPBOrdenada.filter(p => p.cliente === planeacion.cliente).sort((a, b) => a.numerodeParte.localeCompare(b.numerodeParte));
            //Se arma el objeto de la planeación por cliente por número de parte
            var datosPorCliente = [];
            var numerodeParte = [];
            var numerodeParteCantidad = [];
            var numerodePartePorcentaje = [];
            await Promise.all(porClientes.map(async (p, i) => {
                numerodeParte.push(p.numerodeParte + " (" + p.cantidadPiezas + "p)");
                numerodeParteCantidad.push(p.cantidadPiezas);
                numerodePartePorcentaje.push((p.cantidadPiezas / planeacion.cantidadPiezas * 100).toFixed(2));
                datosPorCliente.push({
                    numero: i + 1,
                    //cliente: p.cliente,
                    numerodeParte: p.numerodeParte,
                    racks: p.racks,
                    ciclos: p.ciclos,
                    cantidadPiezas: p.cantidadPiezas,
                    porcentaje: (p.cantidadPiezas / planeacion.cantidadPiezas * 100).toFixed(2) + " %"
                })

            }));
            graficasPorCliente.push({
                encabezado: "Planeación base por número de parte de " + planeacion.cliente + " " + Moment(fechaPB).format("DD/MM/YYYY"), //Encabezado de la sección
                encabezadoTabla: ["Número", "Número de parte", "Racks", "Ciclos", "Cantidad", "Porcentaje"],
                datosTabla: datosPorCliente,
                datosgraficapie: {
                    labels: numerodeParte,
                    datasets: [
                        {
                            label: 'Porcentaje por número de parte',
                            data: numerodePartePorcentaje,
                            backgroundColor: backgroundColorRGB,
                            borderColor: borderColorRGB,
                            borderWidth: 1,
                        },
                    ],
                },
                //Objeto con los datos de la gráfica pie {label: ["label1", "label2"], data: [{data: [10, 20], backgroundColor: ["#FF6384", "#36A2EB"]}]}, borderColor: ["#FF6384", "#36A2EB"]}, borderWidth: 1}
                Piedetabla: (planeacion.cantidadPiezas ? planeacion.cantidadPiezas + " PIEZAS" : "") + "  " + (planeacion.racks ? planeacion.racks + " RACKS " : "") + ((planeacion.racks / 19).toFixed(2) + " HORAS DE PRODUCCIÓN") + "   " + (planeacion.ciclos ? planeacion.ciclos + " CICLOS" : ""),
                tablaizquierda: false,
            });
            /**
             * 
             */
            return planeacion;
        }));
        if (datoscc.length > 0) {
            graficasPorCliente[0] = {
                encabezado: "Planeación base por cliente " + Moment(fechaActual).format("DD/MM/YYYY"), //Encabezado de la sección
                encabezadoTabla: ["Número", "Cliente", "Racks", "Ciclos", "Cantidad", "Porcentaje"],
                datosTabla: datoscc,
                datosgraficapie: {
                    labels: clientescc,
                    datasets: [
                        {
                            label: 'Porcentaje por cliente',
                            data: porcentajePiezasPorCliente,
                            backgroundColor: backgroundColorRGB,
                            borderColor: borderColorRGB,
                            borderWidth: 1,
                        },
                    ],
                },
                //Objeto con los datos de la gráfica pie {label: ["label1", "label2"], data: [{data: [10, 20], backgroundColor: ["#FF6384", "#36A2EB"]}]}, borderColor: ["#FF6384", "#36A2EB"]}, borderWidth: 1}
                Piedetabla: (cantidadTotalPiezas ? cantidadTotalPiezas + " PIEZAS" : "") + "  " + (racks ? racks.toFixed(2) + " RACKS " : "") + ((racks / 19).toFixed(2) + " HORAS DE PRODUCCIÓN") + "   " + (ciclos ? ciclos + " CICLOS" : ""),
                tablaizquierda: false,
            };
        }
        return {
            graficasPorCliente: graficasPorCliente,
        };
    }
    //Función que obtiene los datos de seguimiento de la planeación base
    async function obtenerDatosPBS(fechaActual, datosPBF, proceso, horaSeguimiento) {
        //Se obtienen los datos de la planeación base por fecha
        var datoscc = [];
        var numero = 1; //Se inicializa el número para el primer cliente
        var racks = 0;
        var ciclos = 0;
        var planeacionesANP = [];
        const cantidadTotalPiezas = datosPBF.reduce((total, planeaciob) => total + planeaciob.cantidadPiezas, 0);
        //********************************************************************* */
        //Se determinan los datos de la planeación base de los clientes dependiendo el proceso
        const datosPBFP = (proceso === "Ecoat") ? datosPBF.filter(pbe => (pbe.Ecoat === true) || (!pbe.Ecoat && !pbe.Pcoat)) :
            (proceso === "Pcoat") ? datosPBF.filter(pbe => pbe.Pcoat === true) : datosPBF;
        //Se obtienen los dato del plan de producción para determinar el avance
        const seguimiento = await seguimientoProduccion(datosPBF, horaSeguimiento);
        var planeacionsf = seguimiento.planeacionsf ? seguimiento.planeacionsf : [];

        //********************************************** */
        //Se recorren los datos de la planeación base
        planeacionsf = planeacionsf.sort((a, b) => a.cliente.localeCompare(b.cliente));
        await Promise.all(planeacionsf.map(async (planeacion) => {
            const clientePlaificado = datosPBFP.filter(pbe => pbe.cliente === planeacion.cliente && pbe.numerodeParte === planeacion.numerodeParte);
            if (clientePlaificado.length > 0 ||
                (proceso === "Ecoat" && planeacion.piezasenPintado > 0 && planeacion.prioridadAtencion === "Sin planificar") ||
                (proceso === "Pcoat" && planeacion.piezasenPintadoPC > 0 && planeacion.prioridadAtencion === "Sin planificar")) {
                //Se obtiene el cliente de la planeación
                const cliente = planeacion.cliente;
                //Se obtiene la cantidad de piezas de la planeación
                const piezasenPintado = (proceso === "Ecoat") ? planeacion.piezasenPintado : planeacion.piezasenPintadoPC;
                //Se obtiene la cantidad de piezas de la planeación
                const cantidadPiezas = planeacion.cantidadPiezas;
                //Se obtienen los racks de la planeación
                const rackscc = parseFloat(planeacion.racks ? planeacion.racks : 0);
                //Se suman los racks de la planeación
                racks += parseFloat(planeacion.racks ? planeacion.racks : 0);
                //se obtiene los ciclos de la planeación
                const cicloscc = parseInt(planeacion.ciclos ? planeacion.ciclos : 0);
                //Se suman los ciclos de la planeación
                ciclos += parseInt(planeacion.ciclos ? planeacion.ciclos : 0);

                //Se verifica si el cliente ya existe en el arreglo
                const clienteExistente = datoscc.find(c => c.cliente === cliente);
                if (clienteExistente) {
                    //Si el cliente ya existe, se suma la cantidad de piezas
                    clienteExistente.piezasenPintado += piezasenPintado;
                    clienteExistente.cantidadPiezas += cantidadPiezas;
                    clienteExistente.racks += rackscc;
                    clienteExistente.ciclos += cicloscc;
                } else {//Si el cliente no existe, se agrega a los arreglos correspondientes
                    //clientescc.push(cliente); // Agrega el cliente al arreglo de clientes
                    //cantidadPiezascc.push(cantidadPiezas); //Se agrega la cantidad de piezas al arreglo de cantidades
                    datoscc.push({ //Se agregan todos los datos al arreglo de datos
                        numero: numero,
                        cliente: cliente,
                        racks: rackscc,
                        ciclos: cicloscc,
                        cantidadPiezas: cantidadPiezas,
                        porcentaje: piezasenPintado,
                        piezasenPintado: piezasenPintado,
                        porcentajePintado: piezasenPintado
                    });
                    numero++; //Se incrementa el número para el siguiente cliente
                }
            }
        }));
        //setDatosOriginales(planeacionsf);
        var clientescc = [];
        var cantidadPiezascc = [];
        var cantidadPiezasPintadas = [];
        var porcentajePiezasPorCliente = [];
        var graficasPorCliente = [{}];
        var coloresSeguimiento = [];
        await Promise.all(datoscc.map(async (planeacion) => {
            //Se obtienen los datos de la columna cliente
            clientescc.push(planeacion.cliente + " (" + planeacion.piezasenPintado + "pp)");
            //Se obtienen los datos de la columna cantidadPiezas
            cantidadPiezascc.push(planeacion.cantidadPiezas);
            //Se obtienen los datos de la columna piezasenPintado
            cantidadPiezasPintadas.push(planeacion.piezasenPintado);
            //Se calcula el porcentaje de piezas por cliente
            porcentajePiezasPorCliente.push(((planeacion.cantidadPiezas / cantidadTotalPiezas) * 100).toFixed(2));
            planeacion.racks = planeacion.racks ? planeacion.racks.toFixed(2) : 0;
            planeacion.porcentaje = (planeacion.cantidadPiezas ? ((planeacion.cantidadPiezas / cantidadTotalPiezas) * 100).toFixed(2) : 0) + " %";
            planeacion.porcentajePintado = (planeacion.piezasenPintado ? ((planeacion.piezasenPintado / planeacion.cantidadPiezas) * 100).toFixed(2) : 0) + " %";
            //Se arman los datos por clientes
            const porClientes = planeacionsf.filter(p => p.cliente === planeacion.cliente).sort((a, b) => a.numerodeParte.localeCompare(b.numerodeParte));
            //Se obtiene el color por el porcentaje de avance en pintado
            const colorAPS = planeacion.piezasenPintado === 0 ? "rgb(196, 33, 4)" :
                planeacion.piezasenPintado <= (planeacion.cantidadPiezas / 4) ? "rgb(243, 123, 24)" :
                    planeacion.piezasenPintado <= (planeacion.cantidadPiezas / 2) ? "rgb(243, 247, 26)" :
                        planeacion.piezasenPintado < (planeacion.cantidadPiezas) ? "rgb(29, 241, 170)" :
                            planeacion.piezasenPintado >= planeacion.cantidadPiezas ? "rgb(32, 153, 5)" :
                                "rgb(196, 33, 4)";
            coloresSeguimiento.push(colorAPS);
            //Se arma el objeto de la planeación por cliente por número de parte
            var datosPorCliente = [];
            var numerodeParte = [];
            var numerodeParteCantidad = [];
            var numerodePartePPintado = [];
            var backgroundCumplimiento = [];
            var porcentajePorNumerodeParte = [];
            await Promise.all(porClientes.map(async (p, i) => {
                const clientePlaificado = datosPBFP.filter(pbe => pbe.cliente === p.cliente && pbe.numerodeParte === p.numerodeParte);
                if (clientePlaificado.length > 0 ||
                    (proceso === "Ecoat" && p.piezasenPintado > 0 && p.prioridadAtencion === "Sin planificar") ||
                    (proceso === "Pcoat" && p.piezasenPintadoPC > 0 && p.prioridadAtencion === "Sin planificar")) {
                    //Se determina qué dato de pintado se tiene que presentar, dependiendo si se trata de Ecoat o Pcoat
                    p.piezasenPintado = (proceso === "Ecoat") ? p.piezasenPintado : p.piezasenPintadoPC;
                    numerodeParte.push(p.numerodeParte + " (" + p.piezasenPintado + "pp)");
                    numerodeParteCantidad.push(p.cantidadPiezas);
                    numerodePartePPintado.push(p.piezasenPintado);
                    porcentajePorNumerodeParte.push(((p.cantidadPiezas / planeacion.cantidadPiezas) * 100).toFixed(2));
                    const sPorcentaje = (p.piezasenPintado / p.cantidadPiezas * 100).toFixed(2);
                    const colorS = p.prioridadAtencion === "Sin planificar" ? "rgba(184, 11, 112, 0.774)" :
                        p.piezasenPintado === 0 ? "rgb(196, 33, 4)" :
                            p.piezasenPintado <= (p.cantidadPiezas / 4) ? "rgb(243, 123, 24)" :
                                p.piezasenPintado <= (p.cantidadPiezas / 2) ? "rgb(243, 247, 26)" :
                                    p.piezasenPintado < (p.cantidadPiezas) ? "rgb(29, 241, 170)" :
                                        p.piezasenPintado >= p.cantidadPiezas ? "rgb(32, 153, 5)" :
                                            "rgb(196, 33, 4)";
                    backgroundCumplimiento.push(colorS);
                    datosPorCliente.push({
                        numero: i + 1,
                        //cliente: p.cliente,
                        numerodeParte: p.numerodeParte,
                        racks: p.racks,
                        ciclos: p.ciclos,
                        cantidad: p.cantidadPiezas,
                        porcentajePiezas: ((p.cantidadPiezas / planeacion.cantidadPiezas) * 100).toFixed(2) + " %",
                        piezasenPintado: p.piezasenPintado,
                        prioridadAtencion: p.prioridadAtencion,
                        porcentajePintado: sPorcentaje + " %"
                    });
                    //Se determina el color de fondo de los por número de parte
                }
            }));
            graficasPorCliente.push({
                encabezado: "Pintado por número de parte de " + planeacion.cliente + " " + Moment(fechaActual).format("DD/MM/YYYY"), //Encabezado de la sección
                encabezadoTabla: ["#", "Número de parte", "Racks", "Ciclos", "Cantidad", "Porcentaje", "Piezas Pintadas", "Prioridad", "Porcentaje pintado"],
                datosTabla: datosPorCliente,
                datosgraficapie: {
                    labels: numerodeParte,
                    datasets: [
                        {
                            label: 'piezas planeadas',
                            data: numerodeParteCantidad,
                            backgroundColor: backgroundCumplimiento,
                            borderColor: ["rgba(223, 231, 212, 0.75)"],
                            borderWidth: 1,
                        },
                    ],
                },
                //Objeto con los datos de la gráfica pie {label: ["label1", "label2"], data: [{data: [10, 20], backgroundColor: ["#FF6384", "#36A2EB"]}]}, borderColor: ["#FF6384", "#36A2EB"]}, borderWidth: 1}
                Piedetabla: (planeacion.piezasenPintado ? planeacion.piezasenPintado + " PIEZAS" : "") + "  " + (planeacion.racks ? planeacion.racks + " RACKS " : "") + ((planeacion.racks / 19).toFixed(2) + " HORAS DE PRODUCCIÓN") + "   " + (planeacion.ciclos ? planeacion.ciclos + " CICLOS" : ""),
                tablaizquierda: false,
            });
            /**
             * 
             */
            return planeacion;
        }));
        if (datoscc.length > 0) {
            graficasPorCliente[0] = {
                encabezado: "Cumplimiento de pintado por cliente " + Moment(fechaActual).format("DD/MM/YYYY"),
                encabezadoTabla: ["Número", "Cliente", "Racks", "Ciclos", "Cantidad", "Porcentaje", "Piezas Pintadas", "Porcentaje pintado"],
                datosTabla: datoscc,
                datosgraficapie: {
                    labels: clientescc,
                    datasets: [
                        {
                            label: 'Piezas planeadas',
                            data: cantidadPiezascc,
                            backgroundColor: coloresSeguimiento,
                            borderColor: ["rgba(223, 231, 212, 0.75)"],
                            borderWidth: 1,
                        },
                    ],
                },
                //Objeto con los datos de la gráfica pie {label: ["label1", "label2"], data: [{data: [10, 20], backgroundColor: ["#FF6384", "#36A2EB"]}]}, borderColor: ["#FF6384", "#36A2EB"]}, borderWidth: 1}
                Piedetabla: (cantidadTotalPiezas ? cantidadTotalPiezas + " PIEZAS" : "") + "  " + (racks ? racks.toFixed(2) + " RACKS " : "") + ((racks / 19).toFixed(2) + " HORAS DE PRODUCCIÓN") + "   " + (ciclos ? ciclos + " CICLOS" : ""),
                tablaizquierda: false,
            };
        }
        return {
            graficasPorCliente: graficasPorCliente,
        };
    }
    function onChangesRFechaP(e) {
        e.persist()
        const fecha = e.target.value;
        setFechaPB(fecha);
        datosPlaneacionBF(fecha);
    }
    async function handleInputChange(e) {
        setCargando1(true);
        const { name, value } = e.target;
        setHora(value);
        //Se obtienen los datos de la planeación base
        const datosPlaneacionBS = await obtenerDatosPBS(fechaPB, datosOriginales, "Ecoat", value);
        setDatosPBS(datosPlaneacionBS);
        setCargando1(false);
    };
    async function handleInputChangeP(e) {
        setCargando1(true);
        const { name, value } = e.target;
        setHora(value);
        //Se obtienen los datos de la planeación base
        const datosPlaneacionBSP = await obtenerDatosPBS(fechaPB, datosOriginales, "Pcoat", value);
        setDatosPBSP(datosPlaneacionBSP);
        setCargando1(false);
    };


    return (
        <>

            <div className="conteiner2">
                <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                    {mensajeAlert}
                </Alert>
                {cargando === true && (
                    <Row>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                            <img width="150px" alt="cargando" src="assets/img/preloader.gif" />
                        </div>
                    </Row>
                )}
                <Fragment>

                    <Row>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 margintop20px" >
                            <h5 className="  font-weight-bold floatrightleft">Fecha</h5>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-4 col-xs-12 margintop20px" >
                            <Input name="fecha" type="date" value={Moment(fechaPB).format("YYYY-MM-DD")} onChange={onChangesRFechaP} />
                        </div>
                    </Row>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px">
                        <hr className='' />
                        <button className={openPB ? "cbuttonl  cbuttonActivo" : "cbuttonl"} onClick={() => setOpenPB(!openPB)}>
                            <Label className={""}>Planeación base Ecoat</Label>  <Label className={"ml-2"}><IoIcons.IoIosArrowDown hidden={openPB} /> <IoIcons.IoIosArrowUp hidden={!openPB} /></Label>
                        </button>
                        <hr hidden={openPB} className='margintop0px' />
                        <Collapse isOpen={openPB}>
                            <div className="p-3 border">
                                {(datosPBF.graficasPorCliente && datosPBF.graficasPorCliente.length > 0) && (
                                    <>
                                        <Row>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  textaligmentcenter">
                                                <button className="cbutton btn-dark floatrightcenter  " title="Recargar página" onClick={() => { datosPlaneacionBF(fechaPB) }}><IoIcons.IoMdRefresh /> Recargar </button>
                                            </div>
                                        </Row>
                                        {datosPBF.graficasPorCliente.map((graficacliente, index) => (
                                            <Graficapietabla
                                                encabezado={graficacliente.encabezado}
                                                encabezadoTabla={graficacliente.encabezadoTabla}
                                                datosTabla={graficacliente.datosTabla}
                                                datosgraficapie={graficacliente.datosgraficapie}
                                                Piedetabla={graficacliente.Piedetabla}
                                                tablaizquierda={graficacliente.tablaizquierda}
                                                tablaTipo={"PlaneacionBase"}
                                            />
                                        ))}
                                    </>
                                )}
                            </div>

                        </Collapse>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop-10px">
                        <button className={openPP ? "cbuttonl  cbuttonActivo" : "cbuttonl"} onClick={() => setOpenPP(!openPP)}>
                            <Label className={""}>Trazabilidad del Proceso de Aplicación de Recubrimiento Ecoat</Label>  <Label className={"ml-2"}><IoIcons.IoIosArrowDown hidden={openPP} /> <IoIcons.IoIosArrowUp hidden={!openPP} /></Label>
                        </button>
                        <Collapse isOpen={openPP}>
                            {cargando1 === true && (
                                <Row>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                        <img width="150px" alt="cargando" src="assets/img/preloader.gif" />
                                    </div>
                                </Row>
                            )}
                            <div className="p-3 border">
                                {(datosPBS.graficasPorCliente && datosPBS.graficasPorCliente.length > 0) && (
                                    <>
                                        <Row>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  ">
                                                <button className="cbutton btn-dark floatrightcenter  " title="Recargar página" onClick={() => { datosPlaneacionBF(fechaPB) }}><IoIcons.IoMdRefresh /> Recargar </button>
                                                <div className="  textaligmentcenter margintopmobil10px">
                                                    <Label className={" "}>Hora de pintado: {/*hora*/} </Label>
                                                    <Label>
                                                        <select name="prioridad " className=" custom-select ml-1" onChange={e => handleInputChange(e)} >
                                                            <option value="" selected={hora == "" ? true : false} >--</option>
                                                            <option value="07:00" selected={hora == "07:00" ? true : false}>7:00</option>
                                                            <option value="08:00" selected={hora == "08:00" ? true : false}>8:00</option>
                                                            <option value="09:00" selected={hora == "09:00" ? true : false}>9:00</option>
                                                            <option value="10:00" selected={hora == "10:00" ? true : false}>10:00</option>
                                                            <option value="11:00" selected={hora == "11:00" ? true : false}>11:00</option>
                                                            <option value="12:00" selected={hora == "12:00" ? true : false}>12:00</option>
                                                            <option value="13:00" selected={hora == "13:00" ? true : false}>13:00</option>
                                                            <option value="14:00" selected={hora == "14:00" ? true : false}>14:00</option>
                                                            <option value="15:00" selected={hora == "15:00" ? true : false}>15:00</option>
                                                            <option value="16:00" selected={hora == "16:00" ? true : false}>16:00</option>
                                                            <option value="17:00" selected={hora == "17:00" ? true : false}>17:00</option>
                                                            <option value="18:00" selected={hora == "18:00" ? true : false}>18:00</option>
                                                            <option value="19:00" selected={hora == "19:00" ? true : false}>19:00</option>
                                                            <option value="20:00" selected={hora == "20:00" ? true : false}>20:00</option>
                                                        </select>
                                                    </Label>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintopmobil10px  textaligmentcenter">
                                            </div>
                                        </Row>
                                        {datosPBS.graficasPorCliente.map((graficacliente, index) => (
                                            <Graficapietabla
                                                encabezado={graficacliente.encabezado}
                                                encabezadoTabla={graficacliente.encabezadoTabla}
                                                datosTabla={graficacliente.datosTabla}
                                                datosgraficapie={graficacliente.datosgraficapie}
                                                Piedetabla={graficacliente.Piedetabla}
                                                tablaizquierda={graficacliente.tablaizquierda}
                                                tablaTipo={"SeguimientoPintado"}
                                            />
                                        ))}
                                    </>
                                )}
                            </div>

                        </Collapse>

                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px">
                        <hr className='' />
                        <button className={openPBP ? "cbuttonl  cbuttonActivo" : "cbuttonl"} onClick={() => setOpenPBP(!openPBP)}>
                            <Label className={""}>Planeación base Powder</Label>  <Label className={"ml-2"}><IoIcons.IoIosArrowDown hidden={openPBP} /> <IoIcons.IoIosArrowUp hidden={!openPBP} /></Label>
                        </button>
                        <hr hidden={openPBP} className='margintop0px' />
                        <Collapse isOpen={openPBP}>
                            <div className="p-3 border">
                                {(datosPBFP.graficasPorCliente && datosPBFP.graficasPorCliente.length > 0) && (
                                    <>
                                        <Row>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  textaligmentcenter">
                                                <button className="cbutton btn-dark floatrightcenter  " title="Recargar página" onClick={() => { datosPlaneacionBF(fechaPB) }}><IoIcons.IoMdRefresh /> Recargar </button>
                                            </div>
                                        </Row>
                                        {datosPBFP.graficasPorCliente.map((graficacliente, index) => (
                                            <Graficapietabla
                                                encabezado={graficacliente.encabezado}
                                                encabezadoTabla={graficacliente.encabezadoTabla}
                                                datosTabla={graficacliente.datosTabla}
                                                datosgraficapie={graficacliente.datosgraficapie}
                                                Piedetabla={graficacliente.Piedetabla}
                                                tablaizquierda={graficacliente.tablaizquierda}
                                                tablaTipo={"PlaneacionBase"}
                                            />
                                        ))}
                                    </>
                                )}
                            </div>

                        </Collapse>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop-10px">
                        <button className={openPPP ? "cbuttonl  cbuttonActivo" : "cbuttonl"} onClick={() => setOpenPPP(!openPPP)}>
                            <Label className={""}>Trazabilidad del Proceso de Aplicación de Recubrimiento Powder</Label>  <Label className={"ml-2"}><IoIcons.IoIosArrowDown hidden={openPPP} /> <IoIcons.IoIosArrowUp hidden={!openPPP} /></Label>
                        </button>
                        <hr hidden={openPPP} className='margintop0px' />
                        <Collapse isOpen={openPPP}>
                            {cargando1 === true && (
                                <Row>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                        <img width="150px" alt="cargando" src="assets/img/preloader.gif" />
                                    </div>
                                </Row>
                            )}
                            <div className="p-3 border">
                                {(datosPBSP.graficasPorCliente && datosPBSP.graficasPorCliente.length > 0) && (
                                    <>
                                        <Row>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  ">
                                                <button className="cbutton btn-dark floatrightcenter  " title="Recargar página" onClick={() => { datosPlaneacionBF(fechaPB) }}><IoIcons.IoMdRefresh /> Recargar </button>
                                                <div className="  textaligmentcenter margintopmobil10px">
                                                    <Label className={" "}>Hora de pintado: {/*hora*/} </Label>
                                                    <Label>
                                                        <select name="prioridad " className=" custom-select ml-1" onChange={e => handleInputChangeP(e)} >
                                                            <option value="" selected={hora == "" ? true : false} >--</option>
                                                            <option value="07:00" selected={hora == "07:00" ? true : false}>7:00</option>
                                                            <option value="08:00" selected={hora == "08:00" ? true : false}>8:00</option>
                                                            <option value="09:00" selected={hora == "09:00" ? true : false}>9:00</option>
                                                            <option value="10:00" selected={hora == "10:00" ? true : false}>10:00</option>
                                                            <option value="11:00" selected={hora == "11:00" ? true : false}>11:00</option>
                                                            <option value="12:00" selected={hora == "12:00" ? true : false}>12:00</option>
                                                            <option value="13:00" selected={hora == "13:00" ? true : false}>13:00</option>
                                                            <option value="14:00" selected={hora == "14:00" ? true : false}>14:00</option>
                                                            <option value="15:00" selected={hora == "15:00" ? true : false}>15:00</option>
                                                            <option value="16:00" selected={hora == "16:00" ? true : false}>16:00</option>
                                                            <option value="17:00" selected={hora == "17:00" ? true : false}>17:00</option>
                                                            <option value="18:00" selected={hora == "18:00" ? true : false}>18:00</option>
                                                            <option value="19:00" selected={hora == "19:00" ? true : false}>19:00</option>
                                                            <option value="20:00" selected={hora == "20:00" ? true : false}>20:00</option>
                                                        </select>
                                                    </Label>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintopmobil10px  textaligmentcenter">
                                            </div>
                                        </Row>
                                        {datosPBSP.graficasPorCliente.map((graficacliente, index) => (
                                            <Graficapietabla
                                                encabezado={graficacliente.encabezado}
                                                encabezadoTabla={graficacliente.encabezadoTabla}
                                                datosTabla={graficacliente.datosTabla}
                                                datosgraficapie={graficacliente.datosgraficapie}
                                                Piedetabla={graficacliente.Piedetabla}
                                                tablaizquierda={graficacliente.tablaizquierda}
                                                tablaTipo={"SeguimientoPintado"}
                                            />
                                        ))}
                                    </>
                                )}
                            </div>

                        </Collapse>

                    </div>

                </Fragment >
            </div >
        </>
    )
};



export default MetricasPB;